import { setDay as setDayFns } from 'date-fns';

export default function setDay(
  date: Date,
  day: number,
  sundayStart: boolean,
): Date {
  const weekStartsOn = sundayStart ? 0 : 1;
  return setDayFns(date, day, { weekStartsOn });
}
